/* eslint-disable */
// import Datepicker from '../../node_modules/vanillajs-datepicker/js/Datepicker.js'
// import fr from '../../node_modules/vanillajs-datepicker/js/i18n/locales/fr.js'
import Pikaday from 'pikaday'
import moment from 'moment'

// Object.assign(Datepicker.locales, fr)

/**
 * https://github.com/mymth/vanillajs-datepicker
 */
export default {
  name: 'date-picker',

  ui: {
    button: '[js-calendar-toggler]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle() {
        this.calendarwapper.classList.toggle('is-active')
      },
    },
  ],

  componentDidMount() {
    this.calendarwapper = this.el.querySelector('.calendar-wrapper')

    let baseURL = window.location.href.split('/')
    let removed = baseURL.splice(-3, 3)
    baseURL = baseURL.join('/')

    this.availableDates = []
    for (let i = 0; i < this.props.dates.length; i++) {
      this.availableDates.push(
        // moment(this.props.dates[i].dateFormatted).format('YYYY/MM/DD')
        moment(this.props.dates[i].dateFormatted, [
          'MM-DD-YYYY',
          'YYYY-MM-DD',
        ]).format('YYYY-MM-DD')
      )
    }

    let defaultSelectedDate = removed.join('/')

    let i18nOption = {}
    if (window.LANG === 'fr') {
      i18nOption = {
        previousMonth: 'Mois Précédent',
        nextMonth: 'Mois Suivant',
        months: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Decembre',
        ],
        weekdays: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        weekdaysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      }
    } else {
      i18nOption = {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        weekdays: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      }
    }

    var picker = new Pikaday({
      field: this.calendarwapper,
      container: this.calendarwapper,
      firstDay: 1,
      minDate: new Date(2020, 1, 1),
      i18n: i18nOption,
      format: 'YYYY-MM-DD',
      bound: false,
      // defaultDate: moment(defaultSelectedDate).toDate(),
      defaultDate: new Date(defaultSelectedDate),
      setDefaultDate: true,
      disableDayFn: this.disableDays,
      events: this.availableDates,
      onSelect: function() {
        const selectedDate = this.getMoment().format('YYYY/MM/DD')
        window.location.href = `${baseURL}/${selectedDate}`
      },
      // trigger: this.calendarwapper
    })

    /*
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE')

    if (msie > 11 || msie <= 0) {
      Object.assign(Datepicker.locales, fr)

      let baseURL = window.location.href.split('/')
      let removed = baseURL.splice(-3, 3)
      baseURL = baseURL.join('/')

      const availableDates = this.props.dates

      let defaultSelectedDate = removed.join('/')

      this.calendarwapper = this.el.querySelector('.calendar-wrapper')
      this.datepicker = new Datepicker(this.calendarwapper, {
        language: 'fr',
        autohide: true,
        format: 'yyyy/mm/dd', // 'mm/dd/yyyy',
        weekStart: 1,
        minDate: '2020/02/01', // '02/01/2020',
        todayHighlight: false,
        prevArrow: '<',
        nextArrow: '>',
        beforeShowDay: function(date) {
          // let readableDate = moment(date).format('DD-MM-YYYY')
          let readableDate = moment(date).format('YYYY/MM/DD')
          let isSelectable, additionalClasses
          let isUpdatable = true
          for (let i = 0; i < availableDates.length; i++) {
            // console.log(availableDates[i].dateFormatted, readableDate)
            if (isUpdatable) {
              if (availableDates[i].dateFormatted === readableDate) {
                isSelectable = true
                additionalClasses = 'highlighted'
                isUpdatable = false
              } else {
                isSelectable = false
              }
            }
          }

          return {
            enabled: isSelectable,
            classes: additionalClasses,
            // content: htmlFragment,
          }
        },
      })

      this.datepicker.setDate(defaultSelectedDate)
      this.datepicker.element.addEventListener('changeDate', function(e) {
        window.location.href = `${baseURL}/${moment(e.detail.date).format(
          'YYYY/MM/DD'
        )}`
      })
    }
    // this.pipe.write({ action: 'activity-removed', data: that })

    // console.log(this.datepicker.getDate())
  
  */
  },

  disableDays(date) {
    // const testedDate = moment(date).format('YYYY/MM/DD')
    const testedDate = moment(date, ['MM-DD-YYYY', 'YYYY-MM-DD']).format(
      'YYYY-MM-DD'
    )
    let disableDate = true
    for (let i = 0; i < this.availableDates.length; i++) {
      if (this.availableDates[i] === testedDate) {
        disableDate = false
      }
    }

    return disableDate
  },
}
